<div class="flex flex-row justify-center items-center content-center" class="profile-container">
    <div class="basis-6/12 md:basis-9/12 sm:basis-10/12 xs:basis-11/12" class="profile-wrapper">
      <span class="close" (click)="close()"><mat-icon>close</mat-icon></span>
      <div class="flex flex-col justify-center items-center content-center">
        <img class="logo" src="../../../../assets/images/logo-img.svg" />
        <h1 mat-dialog-title>{{ 'COOKIE_POLICY.TITLE' | translate }}</h1>
      </div>
      <div class="text">
        <p>{{ 'COOKIE_POLICY.INTRODUCTION' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.WHAT_ARE_COOKIES' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.WHAT_ARE_COOKIES_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.WHAT_ARE_SCRIPTS' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.WHAT_ARE_SCRIPTS_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.WHAT_IS_WEB_BEACON' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.WHAT_IS_WEB_BEACON_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.COOKIES' | translate }}</h2>

        <h3>{{ 'COOKIE_POLICY.TECHNICAL_COOKIES' | translate }}</h3>
        <p>{{ 'COOKIE_POLICY.TECHNICAL_COOKIES_DESC' | translate }}</p>

        <h3>{{ 'COOKIE_POLICY.STATISTICS_COOKIES' | translate }}</h3>
        <p>{{ 'COOKIE_POLICY.STATISTICS_COOKIES_DESC' | translate }}</p>

        <h3>{{ 'COOKIE_POLICY.MARKETING_COOKIES' | translate }}</h3>
        <p>{{ 'COOKIE_POLICY.MARKETING_COOKIES_DESC' | translate }}</p>

        <h3>{{ 'COOKIE_POLICY.SOCIAL_MEDIA' | translate }}</h3>
        <p>{{ 'COOKIE_POLICY.SOCIAL_MEDIA_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.PLACED_COOKIES' | translate }}{{ 'COOKIE_POLICY.CONSENT' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.CONSENT_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.ENABLE_DISABLE_COOKIES' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.ENABLE_DISABLE_COOKIES_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.YOUR_RIGHTS' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.YOUR_RIGHTS_DESC' | translate }}</p>

        <h2>{{ 'COOKIE_POLICY.CONTACT_DETAILS' | translate }}</h2>
        <p>{{ 'COOKIE_POLICY.CONTACT_DETAILS_DESC' | translate }}</p>
      </div>
      <div class="flex flex-row justify-center items-center content-center" class="margin-top-20">
          <button mat-raised-button color="accent" (click)="close()">Sluiten</button>
      </div>
    </div>
</div>
